import React from 'react';
import { Routes } from 'react-router-dom';
import { Route } from 'react-router';
import SplashScreen from 'auth/components/SplashScreen';
import ProtectedRoute from 'base/components/ProtectedRoute/ProtectedRoute';
import { ForgotPassword, Login } from './auth';
import { ModalContainer } from './modal';
import ErrorPage from './base/errors/containers/ErrorPage';
import AppMain from './base/containers/AppMain';
import ResetPassword from './auth/containers/ResetPasswort';
import GlobalStyles from './theme/global-styles';
import PrivacyPolicy from './auth/components/PrivacyPolicy';
import OfflineApp from './offline/containers/OfflineApp';
import Online from './offline/containers/Online/Online';
import ToastContainer from './base/components/Toast/ToastContainer';
import EnvironmentIndicator from './base/components/EnvironmentIndicator';


const App = () => (
    <>
        <GlobalStyles />
        <EnvironmentIndicator />
        <Online>
            <Routes>
                <Route path="/logintest" element={<SplashScreen />} />
                <Route path="/login/:hasFinished2FaSetup?" element={<Login />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route
                    path="*"
                    element={
                        <ProtectedRoute authenticationPath="/login">
                            <AppMain />
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </Online>
        <OfflineApp />
        <ModalContainer />
        <ToastContainer />
        <ErrorPage />
    </>
);


export default App;
